import { useEffect, useRef, useState } from "react";

const ITEMS = [
  "Engineering Intelligent Infrastructure",
  "Software Services",
  "Integrated Solutions",
  "Smart Infrastructure",
  "Automation",
  "Managed Services",
  "Across Kerala",
];

// Constant visual speed on every screen: duration is derived from the measured
// track width, so phones (narrower track) move as fast as desktop in px/s.
// Speeds reduced a further 10% on ALL views per client request
// (desktop 175 → 157.5 px/s ≈ 16.5s loop, mobile 120 → 108 px/s ≈ 16.1s loop).
const SPEED_PX_PER_SEC = 157.5;
const MOBILE_SPEED_PX_PER_SEC = 108;

export const Marquee = () => {
  const trackRef = useRef(null);
  const [duration, setDuration] = useState(null);

  useEffect(() => {
    const measure = () => {
      const el = trackRef.current;
      if (!el) return;
      const oneCopy = el.scrollWidth / 2; // track holds two identical copies
      const speed = window.innerWidth < 640 ? MOBILE_SPEED_PX_PER_SEC : SPEED_PX_PER_SEC;
      if (oneCopy > 0) setDuration(oneCopy / speed);
    };
    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, []);

  return (
    <div className="border-y border-white/10 bg-nx-navy2 py-6 sm:py-8 overflow-hidden" data-testid="editorial-marquee">
      <div
        ref={trackRef}
        className="flex w-max whitespace-nowrap animate-nx-marquee"
        style={duration ? { animationDuration: `${duration}s` } : undefined}
        data-testid="editorial-marquee-track"
      >
        {[0, 1].map((k) => (
          <div key={k} className="flex shrink-0 items-center">
            {ITEMS.map((t, i) => (
              <span key={`${k}-${t}`} className="flex items-center">
                <span className={`px-8 sm:px-12 font-marcellus text-2xl sm:text-4xl ${i % 2 === 0 ? "nx-text-outline" : "text-nx-goldlight/90"}`}>{t}</span>
                <span className="w-2 h-2 rotate-45 bg-nx-gold/60 shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
